<template>
	<page>
		<module title="会员查询" enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="手机号">
					<c-input name="user_manage_mobilephone" placeholder="模糊匹配"></c-input>
				</m-search-item>
				<m-search-item label="用户名">
					<c-input name="login_name" placeholder="模糊匹配"></c-input>
				</m-search-item>
				<m-search-item label="昵称">
					<c-input name="nick_name" placeholder="模糊匹配"></c-input>
				</m-search-item>
				<m-search-item label="状态" style="width:180px">
					<c-checkbox-group name="state" :options="stateType"></c-checkbox-group>
				</m-search-item>
			</m-search>
			
			<m-operate>
			    <c-button v-if="auth('b_platform_user_edit')" color="sys" @click="editUser()">新增会员</c-button>
			</m-operate>
			
            <c-table ref="table">
				
				<c-table-column
					label="手机号"
					name="user_manage_mobilephone"
					width="130"
				>
				</c-table-column>
				
				<c-table-column
					label="用户名"
					name="login_name"
					width="150"
				>
				</c-table-column>

				<c-table-column
					label="昵称"
					name="nick_name"
		          width="130"
		        >
					<template v-slot="{data}">
						<span v-if="data.nick_name && data.nick_name!=''">{{data.nick_name}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="下单数"
					name="order_count"
					width="60"
				>
				</c-table-column>

				<c-table-column
					label="退款单数"
					name="refund_count"
					width="80"
				>
				</c-table-column>

				<c-table-column
					label="注册时间"
					name="create_date"
					width="140"
				>
				</c-table-column>

				<c-table-column
					label="注册来源"
					name="user_resource"
					width="100"
				>
					<template v-slot="{data}">
						{{userResourceMap[data.user_resource]}}
					</template>
				</c-table-column>

				<c-table-column
					label="状态"
					name="state"
					width="50"
				>
					<template v-slot="{data}">
						<span v-if="data.state == 1" style="color:darkgreen">启用</span>
						<span v-if="data.state == 2" style="color:red">禁用</span>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="70"
				>
					<template v-slot="{data}">
						<c-table-button v-if="auth('b_platform_user_state') && data.state == 2"  @click="updateState(1,data)">启用</c-table-button>
						<c-table-button v-if="auth('b_platform_user_state') && data.state == 1"  @click="updateState(2,data)">禁用</c-table-button>
		          </template>
				</c-table-column>
			</c-table>
			
			<c-dialog ref="editUserDialog" title="新增会员" width="500" @resolve="submitEditUser">
				<c-form ref="edit_form"  unit-width="100%">
					<c-form-item label="手机号" required>
						<c-input name="mobile_phone" type="number" decimal="0" placeholder="请输入11位手机号" maxlength="11"></c-input>
					</c-form-item>
					<c-form-item label="用户名" tip="用于登录，只允许包含中文、英文字母、数字、下划线，长度在1-16位">
						<c-input name="login_name" maxlength="16"></c-input>
					</c-form-item>
					<c-form-item label="昵称" tip="不设置将由系统自动生成，只允许中文、英文最大长度为30个字符">
						<c-input name="nick_name" maxlength="30"></c-input>
					</c-form-item>
				</c-form>
			</c-dialog>

		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

  export default {
		name: 'm_platform_user',
		components: {
			
		},

		data() {
			return {
				userResourceMap: {
					'OMS':'管理后台',
					'PC':'PC电脑',
					'IOS':'苹果APP',
					'ANDROID':'安卓APP',
					'MINI':'微信小程序',
					'RETAIL_MINI':'微信小程序',
					'BARGAIN':'砍价页',
					'H5':'H5页'
				},
				stateType:[
					{
						name:'启用',
						value:1
					},{
						name:'禁用',
						value:2
					}
				]
			}
		},
		computed: {
			...mapState(['systemConfig']),
		},
		mounted() {
			this.$refs.search.search();
		},

		methods: {
			searchHandle(data) {
				data.query_type = 1;
				this.$refs.table.load({
					url: '/platform_user/list',
					data
				});
			},
			updateState(type,val) {
				this.$confirm({
					title: '温馨提示',
					message: '确定要'+(type==1?'启用':'禁用')+'【'+val.user_manage_mobilephone+'】吗？',  // 提示内容,
					resolve: () => {
						this.request({
							url: '/platform_user/update_state',
							data: {platform_user_id:val.platform_user_id,state:type},
							loading: true,
							success: data => {
								this.$message({
									type:'success',
									message: '操作成功'
								});
								this.$refs.table.update();
							}
						});
					},
					cancel: () => {}  // 确定按钮回调
				});
			},
			/**打开 新增/编辑 弹窗**/
			editUser(){
				//清空表单数据
				this.$refs.edit_form.clear();
				this.$refs.editUserDialog.open();
			},
			/**提交修改**/
			submitEditUser(stop){
				stop();
				this.$refs.edit_form.submit({
				  url: '/platform_user/add',
				  rule: {
						mobile_phone: '请输入用户手机号'
				  },
				  success: (data, res) => {
					  this.$message({
						  type:'success',
						  message:'新增会员成功！'
					  });
					  this.$refs.table.update();
					  //关闭弹窗
					  this.$refs.editUserDialog.close();
				  }
				});
			}
		}
	}
</script>